import React from 'react';
import { Helmet } from 'react-helmet';
import '../css/TermsConditions.css';

const TermsConditions = () => {
  return (
    <div>
      <Helmet>
        <title>Shivai Travels Pune | Terms & Conditions</title>
        <meta
          name="description"
          content="Terms & Conditions for Shivai Travels Pune outstation and local cab services."
        />
      </Helmet>

      <div className="breadcrumb-bar">
        <div className="container">
          <div className="row align-items-center text-center">
            <div className="col-md-12 col-12">
              <h2 className="breadcrumb-title text-white">
                Terms & Conditions
              </h2>
            </div>
          </div>
        </div>
      </div>

      {/* Terms Section */}
      <section className="terms-section">
        <div className="container">
          <div className="row g-0">
            <div className="col-md-7">
              <div className="terms-content">

                <p>
                  <b className="highlight">1. Booking Confirmation:</b> <br />
                  All Shivai Travels bookings in Pune are subject to vehicle availability.
                  Confirmation will be provided after advance payment or approval from our team.
                </p>

                <p>
                  <b className="highlight">2. Vehicle Usage:</b> <br />
                  The vehicle is provided only for passenger transport.
                  Transporting commercial goods or illegal items is strictly prohibited.
                </p>

                <p>
                  <b className="highlight">3. Payment Policy:</b> <br />
                  Payments can be made via online transfer, UPI, or cash.
                  Advance payment is mandatory for outstation, wedding, or corporate bookings.
                </p>

                <p>
                  <b className="highlight">4. Cancellation & Rescheduling:</b> <br />
                  Cancellations must be made in advance. Charges may apply based on
                  the time of cancellation and booking type.
                </p>

                <p>
                  <b className="highlight">5. Passenger Responsibility:</b> <br />
                  Customers must provide correct pickup locations in Pune or nearby areas.
                  Delays caused by incorrect information may incur waiting charges.
                </p>

                <p>
                  <b className="highlight">6. Seating & Baggage:</b> <br />
                  Passenger count must not exceed the vehicle seating capacity.
                  Limited luggage space is available; excess baggage may attract additional charges.
                </p>

                <p>
                  <b className="highlight">7. Driver Duty Hours:</b> <br />
                  Driver working hours are limited as per transport rules.
                  Extended usage may require driver allowance or replacement.
                </p>

                <p>
                  <b className="highlight">8. Safety Guidelines:</b> <br />
                  Wearing seatbelts is mandatory. Any damage caused to the vehicle
                  by passengers will be chargeable.
                </p>

                <p>
                  <b className="highlight">9. Refusal of Service:</b> <br />
                  We reserve the right to cancel or refuse service in cases of
                  misbehavior, intoxication, or unsafe conditions.
                </p>

                <p>
                  <b className="highlight">10. Jurisdiction:</b> <br />
                  All disputes shall be governed under Pune, Maharashtra jurisdiction.
                </p>

                <h3>Rental Policy</h3>

                <p>
                  <b className="highlight">Local & Outstation Use:</b> <br />
                  Shivai Travels rentals are available for Pune local travel,
                  outstation trips, weddings, corporate events, and group tours.
                </p>

                <p>
                  <b className="highlight">Toll, Parking & Taxes:</b> <br />
                  Toll charges, parking fees, and state taxes are payable by the customer
                  unless specified in the booking.
                </p>

                <h3>Refund Policy</h3>

                <p>
                  <b className="highlight">Eligible Refunds:</b> <br />
                  Refunds depend on cancellation timing and booking category.
                </p>

                <p>
                  <b className="highlight">Refund Timeline:</b> <br />
                  Approved refunds will be processed within 5–7 working days
                  to the original payment method.
                </p>

                <p>
                  <b className="highlight">No-Show Policy:</b> <br />
                  No refunds will be provided for no-shows or last-minute cancellations.
                </p>

              </div>
            </div>
          </div>

          {/* Contact Info */}
          <div className="contact-info">
            <h2>Contact Us</h2>

            <p>
              For Shivai Travels booking support in Pune, contact us:
            </p>

            <ul>
              <li>
                <b>Phone:</b>{' '}
                <a href="tel:+919689815477">+91 9689815477</a>
              </li>

              <li>
                <b>Email:</b>{' '}
                <a href="mailto:booking@shivaitravels.com">
                  booking@shivaitravels.com
                </a>
              </li>

              <li>
                <b className="darkcolorrr">Address:</b>
                <br />
                <h6>Shivai Travels</h6>
                Shop no 1, Kamdhenu nagar, Guru mauli society,
                Vadgaon road, Near super bazar, Alandi, Pune 412105
              </li>
            </ul>
          </div>
        </div>
      </section>
    </div>
  );
};

export default TermsConditions;